import { Component } from '@angular/core';

@Component({
    template: `placeholder for run applications`
})
export class RunApplicationsComponent {}
